import Api from '@/api/Api'
import toast from '@/mixins/toast'
import router from '@/router'

export default {

    fetchUserById (id) {
        return Api().get('/users/'+ id).then( (response) => {
                return response.data;
            })
            .catch( error => {
                console.log(error)
                if (error.response) {
                      if (error.response.status === 401) {
                          toast.error( "Your session has expired.  Please login again.", "401: Unauthorized")
                          router.replace('/login')
                      } 
                      else {
                        toast.error( error.response.message, "Error")
                      }
                      
                    } else if (error.request) {
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },
    fetchUserByUsername (username) {
        return Api().get('/user-info/'+ username).then( (response) => {
                return response.data;
            })
            .catch( error => {
                console.log(error)
                if (error.response) {
                      if (error.response.status === 401) {
                          toast.error( "Your session has expired.  Please login again.", "401: Unauthorized")
                          router.replace('/login')
                      } 
                      else {
                          toast.error( error.response.message, "Error")  
                      }
                      
                    } else if (error.request) {
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },    
    fetchUsersByAgencyId(payload) {
        return Api().get('/users/agency', payload).then( (response) => {
                return response.data;
            })
            .catch( error => {
                // console.log(error)
                // toast.error( error.data.message )
                if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);

                      if (error.response.status === 401) {
                          toast.error( "Your session has expired.  Please login again.", "401: Unauthorized")
                          router.replace('/login')
                      } 

                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },

    fetchInActiveUsers () {
        return Api().get('/users/inactive/list').then( (response) => {
                return response.data;
            })
            .catch( error => {
                console.log(error)
                if (error.response) {
                      if (error.response.status === 401) {
                          toast.error( "Your session has expired.  Please login again.", "401: Unauthorized")
                          router.replace('/login')
                      } 
                      else {
                        toast.error( error.response.message, "Error")
                      }
                      
                    } else if (error.request) {
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },

    addUser (payload) {
      
        return Api().post('/register', payload).then( (response) => {
                return response.data;
            })
            .catch( error => {
                // console.log(error)
                // toast.error( error.data.message )
                if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      //toast.error(error.response.data.message, error.response.data.status + ": Error")
                      toast.error( error.response.data.message, error.response.data.status + ":"+ error.response.data.title)
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);

                      // if (error.response.status = 401) {
                      //     toast.error( "Your session has expired.  Please login again.", "401: Unauthorized")
                      //     router.replace('/login')
                      // } 


                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },

    updateUser (payload) {
        return Api().put('/user', payload).then( (response) => {
                return response.data;
            })
            .catch( error => {
                // console.log(error)
                // toast.error( error.data.message )
                if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);

                      if (error.response.status === 401) {
                          toast.error( "Your session has expired.  Please login again.", "401: Unauthorized")
                          router.replace('/login')
                      } 

                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },

    updateStatus (payload) {
        return Api().put('/user/status', payload).then( (response) => {
                return response.data;
            })
            .catch( error => {
                // console.log(error)
                // toast.error( error.data.message )
                if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);

                      if (error.response.status === 401) {
                          toast.error( "Your session has expired.  Please login again.", "401: Unauthorized")
                          router.replace('/login')
                      } 

                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },

    sendVCode (payload) {
        return Api().post('/user/send_vcode', payload).then( (response) => {
                return response.data;
            })
            .catch( error => {
                // console.log(error)
                // toast.error( error.data.message )
                if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);

                      if (error.response.data.status === 401) {
                          toast.error( "Your session has expired.  Please login again.", "401: Unauthorized")
                          router.replace('/login')
                      }
                      else {
                          toast.error( error.response.data.message, error.response.data.status +": Error")
                      }

                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },

    verifyVCode (payload) {
        return Api().post('/user/verify_vcode', payload).then( (response) => {
                return response.data;
            })
            .catch( error => {
                // console.log(error)
                // toast.error( error.data.message )
                if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);

                      if (error.response.status === 401) {
                          toast.error( "Your session has expired.  Please login again.", "401: Unauthorized")
                          router.replace('/login')
                      }

                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },
  
}    


// WEBPACK FOOTER //
// ./src/api/UserService.js